package ru.villawonka.app.presentation.screens.variantPicker.compose.view

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.extensions.AppSeparator
import ru.villawonka.app.presentation.design.theme.surfaceLand
import ru.villawonka.app.presentation.screens.variantPicker.model.VariantPickerItemUIModel

@Composable
internal fun VariantPickerListView(
    selectedItem: VariantPickerItemUIModel?,
    items: List<VariantPickerItemUIModel>,
    onClick: (VariantPickerItemUIModel) -> Unit
) {
    Column(
        modifier = Modifier
            .background(
                color = MaterialTheme.colors.surfaceLand,
                shape = RoundedCornerShape(16.dp)
            )
            .padding(16.dp)
    ) {
        items.forEachIndexed { index, item ->
            VariantPickerItemView(
                title = item.title,
                subtitle = item.subtitle,
                selected = item == selectedItem
            ) {
                onClick(item)
            }

            if (index != items.size - 1) {
                AppSeparator(verticalPadding = 16.dp)
            }
        }
    }
}